export const promptContents = {
  createUser: 'Upon login User will be forced to change password. INCC#2023 is default password for initial login',
  soundSettings: 'You can turn the Sound On/Off in your Profile',
  noSoundSettings: 'You have no permission to manage Sound Settings',
  inactivateUnit: 'Ability for customer to assign a subscriber/hybrid as inactive to not affect Healthscore.',
  dbDumpWarning: 'INCC is running in DB Dump Replication Mode. To reach the recent data and statistics please check Primary',
  emailTemplateSettings: 'These settings allow options to select what information to show in email template that is sent if notification is triggered.'
};
